import { uploadMedia } from "./uploadMedia";
import ENV from "../env";

async function createUpdateEvent({
  eventFormatted,
  tickets,
  isUpdate,
  oldMediaUrl,
  oldLogoUrl,
  oldEmailHeaderImageUrl,
}) {
  try {
    if (!eventFormatted.mediaAlreadyUploaded && (!isUpdate || (isUpdate && eventFormatted.mediaUrl !== oldMediaUrl))) {
      const url = await uploadMedia(
        eventFormatted.mediaUrl,
        `events/${eventFormatted.id}`,
        eventFormatted.mediaIsVideo,
      );
      eventFormatted.mediaUrl = url;
    }
    delete eventFormatted.mediaAlreadyUploaded;

    if (eventFormatted.logoUrl && (!isUpdate || eventFormatted.logoUrl !== oldLogoUrl)) {
      const url = await uploadMedia(
        eventFormatted.logoUrl,
        `events/logos/${eventFormatted.id}`,
        false,
      );
      eventFormatted.logoUrl = url;
    }

    const ticketEmailCustomization = eventFormatted.ticketEmailCustomization;
    if (
      ticketEmailCustomization?.headerImageUrl &&
      (!isUpdate || ticketEmailCustomization.headerImageUrl !== oldEmailHeaderImageUrl)
    ) {
      const url = await uploadMedia(
        ticketEmailCustomization.headerImageUrl,
        `events/email-images/${eventFormatted.id}.jpg`,
        false,
        {
          compressImage: {
            maxWidth: 1200,
            maxHeight: 520,
            maxBytes: 140 * 1024,
            mimeType: "image/jpeg",
            initialQuality: 0.82,
          },
        },
      );
      eventFormatted.ticketEmailCustomization = {
        ...ticketEmailCustomization,
        headerImageUrl: url,
      };
    }

    const response = await fetch(`${ENV.firebaseApiUrl}/ticketing/create-update`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        eventFormatted,
        tickets,
        isUpdate,
      }),
    });

    const responseBody = await response.text();
    let resData = {};
    try {
      resData = responseBody ? JSON.parse(responseBody) : {};
    } catch {
      resData = { error: responseBody };
    }

    if (!response.ok) {
      throw new Error(resData?.error || resData?.message || "Create / update ticketing failed");
    }

    return resData;
  } catch (error) {
    console.error("Error while creating/updating the event:", error);
    throw new Error(`Error while creating/updating the event: ${error.message}`);
  }
}

export default createUpdateEvent;
